import apiClient from './apiClient';

export interface ComplianceCheck {
  id: string;
  propertyId: number;
  propertyAddress: string;
  checkType: string;
  certificateUrl?: string;
  expiryDate?: string;
  notes?: string;
  status: string;
  completedDate?: string;
  certificateNumber?: string;
  inspectorName?: string;
  inspectorLicense?: string;
  nextDueDate?: string;
  reminderDaysBefore: number;
  daysUntilExpiry?: number;
  isExpired: boolean;
  needsAttention: boolean;
}

export interface ComplianceTimeline {
  id: string;
  checkType: string;
  date: string;
  status: string;
  description: string;
  isOverdue: boolean;
}

export interface CreateComplianceCheckRequest {
  propertyId: number;
  checkType: string;
  expiryDate?: string;
  completedDate?: string;
  certificateNumber?: string;
  certificateUrl?: string;
  inspectorName?: string;
  inspectorLicense?: string;
  notes?: string;
  reminderDaysBefore?: number;
}

const complianceApi = {
  // Get all compliance checks for current user
  getAllChecks: () => apiClient.get<ComplianceCheck[]>('/compliance/checks'),

  // Get compliance checks for a specific property
  getPropertyChecks: (propertyId: number) =>
    apiClient.get<ComplianceCheck[]>(`/compliance/property/${propertyId}`),

  // Get compliance timeline for a property
  getPropertyTimeline: (propertyId: number) =>
    apiClient.get<ComplianceTimeline[]>(`/compliance/property/${propertyId}/timeline`),

  // Get checks expiring soon
  getExpiringChecks: (days: number = 30) =>
    apiClient.get<ComplianceCheck[]>(`/compliance/expiring?days=${days}`),

  // Create a new compliance check
  createCheck: (request: CreateComplianceCheckRequest) =>
    apiClient.post<ComplianceCheck>('/compliance/checks', request),

  // Update an existing compliance check
  updateCheck: (id: string, request: CreateComplianceCheckRequest) =>
    apiClient.put<ComplianceCheck>(`/compliance/checks/${id}`, request),

  // Mark a check as completed
  completeCheck: (id: string, completedDate: string, certificateUrl?: string) =>
    apiClient.post<ComplianceCheck>(
      `/compliance/checks/${id}/complete?completedDate=${completedDate}${
        certificateUrl ? `&certificateUrl=${encodeURIComponent(certificateUrl)}` : ''
      }`,
      {}
    ),
};

export default complianceApi;

